if (window.jQuery) {
  var $ = window.jQuery;
  $(function(){
    $(document).ready(function() {
      let scriptsToLoad = [
                              'https://discover.lottedutyfree.com.au/wp-content/plugins/elementor/assets/lib/font-awesome/js/v4-shims.min.js',
                              'https://discover.lottedutyfree.com.au/wp-content/plugins/happy-elementor-addons/assets/vendor/dom-purify/purify.min.js',
                              
                              'https://discover.lottedutyfree.com.au/wp-content/plugins/elementskit-lite/libs/framework/assets/js/frontend-script.js',
                              'https://discover.lottedutyfree.com.au/wp-content/plugins/elementskit-lite/widgets/init/assets/js/widget-scripts.js',
                              
                              'https://discover.lottedutyfree.com.au/wp-content/plugins/elementor/assets/js/webpack.runtime.min.js',
                              'https://discover.lottedutyfree.com.au/wp-content/plugins/elementor/assets/js/frontend-modules.min.js',
                              
                              'https://discover.lottedutyfree.com.au/wp-content/plugins/elementskit-lite/widgets/init/assets/js/animate-circle.min.js',
                              'https://discover.lottedutyfree.com.au/wp-content/plugins/elementskit-lite/widgets/init/assets/js/elementor.js',
                              'https://discover.lottedutyfree.com.au/wp-content/plugins/elementskit/widgets/init/assets/js/elementor.js',
                              'https://discover.lottedutyfree.com.au/wp-content/plugins/elementskit/modules/wrapper-link/assets/js/wrapper.js',
                              'https://discover.lottedutyfree.com.au/wp-content/plugins/elementor/assets/lib/swiper/swiper.min.js'
                              ];
      //let scriptsToLoad = scriptsToLoadList.split(',');

      let pageContentLoaded = false;
      let mainCssLoaded = false;
      var page_embed_url = '',
        page_embed_element = '', 
        collection_menu_embed_url = '', 
        menu_embed_url = '', 
        menu_embed_element = '', 
        top_slider_embed_url = '', 
        top_slider_embed_element = '', 
        right_side_content_embed_url = '', 
        right_side_content_embed_element = '',
        collection_menu_embed_url = '', 
        collection_menu_embed_element = '',
		mainCustomCss = '';
      
      $("#MainContent").addClass('elementor-kit-32');
      
      page_embed_url = $('.page_embed_url').attr('data-embed-url');
      page_embed_element = $('.page_embed_url').attr('data-embed-content');
	  
	  top_slider_embed_url = $('.top_slider_embed_url').attr('data-embed-url');
      top_slider_embed_element = $('.top_slider_embed_url').attr('data-embed-content');
	  
	  right_side_content_embed_url = $('.right_side_content_embed_url').attr('data-embed-url');
      right_side_content_embed_element = $('.right_side_content_embed_url').attr('data-embed-content');
	  
	  menu_embed_url = $('.menu_embed_url').attr('data-embed-url');
      menu_embed_element = $('.menu_embed_url').attr('data-embed-content');

      collection_menu_embed_url = $('.collection_menu_embed_url').attr('data-embed-url');
      collection_menu_embed_element = $('.collection_menu_embed_url').attr('data-embed-content');
	  
	  if( typeof page_embed_url !== 'undefined' ) {
		$.get(page_embed_url, function(response, status, xhr) {
			mainCustomCss = $( $.parseHTML(response) ).filter("#wp-custom-css");
			$(".page_embed_url").append(mainCustomCss);
            mainCssLoaded = true;
		})
	  } else if( typeof top_slider_embed_url !== 'undefined' ) {
		$.get(top_slider_embed_url, function(response, status, xhr) {
			mainCustomCss = $( $.parseHTML(response) ).filter("#wp-custom-css");
			$(".top_slider_embed_url").append(mainCustomCss);
            mainCssLoaded = true;
		})
	  } else if( typeof right_side_content_embed_url !== 'undefined' ) {
		$.get(right_side_content_embed_url, function(response, status, xhr) {
			mainCustomCss = $( $.parseHTML(response) ).filter("#wp-custom-css");
			$(".right_side_content_embed_url").append(mainCustomCss);
            mainCssLoaded = true;
		})
	  } else if( typeof menu_embed_url !== 'undefined' ) {
		$.get(menu_embed_url, function(response, status, xhr) {
			mainCustomCss = $( $.parseHTML(response) ).filter("#wp-custom-css");
			$(".menu_embed_url").append(mainCustomCss);
            mainCssLoaded = true;
		})
	  } else {
    	  mainCssLoaded = true;
	  }
      
      if( typeof collection_menu_embed_url !== 'undefined' ) {
		$.get(collection_menu_embed_url, function(response, status, xhr) {
			mainCustomCss = $( $.parseHTML(response) ).filter("#wp-custom-css");
			$("#MainContent").append(mainCustomCss);
            console.log(mainCustomCss);
          
            mainCssLoaded = true;
		})
	  } else {
    	  mainCssLoaded = true;
	  }
      
	  const checkIFMainCssLoaded = setInterval(function(){
        if( mainCssLoaded ) {
          clearInterval(checkIFMainCssLoaded);
          if( typeof page_embed_url !== 'undefined'  ) {
            pageContentLoaded = false;
            $("#MainContent").load(page_embed_url+' '+page_embed_element, function( response, status, xhr ) {
              var mainPageCss =  $( $.parseHTML(response) ).filter("#elementor-frontend-inline-css");
              $("#MainContent").append(mainPageCss);
              var mainPageStyleCss =  $( $.parseHTML(response) ).filter("style");
              $("#MainContent").append(mainPageStyleCss);
              pageContentLoaded = true;
            });
          }
      
          if( typeof top_slider_embed_url !== 'undefined'  ) {
            pageContentLoaded = false;
            $(".page-top-slider-section").load(top_slider_embed_url+' '+top_slider_embed_element, function( response, status, xhr ) {
              var topSlidePageCss =  $( $.parseHTML(response) ).filter("#elementor-frontend-inline-css");
              $(".page-top-slider-section").append(topSlidePageCss);
              pageContentLoaded = true;
            });
          }
      
          if( typeof right_side_content_embed_url !== 'undefined'  ) {
            $(".page-content-section").load(right_side_content_embed_url+' '+right_side_content_embed_element, function( response, status, xhr ) {
              var contentPageCss =  $( $.parseHTML(response) ).filter("#elementor-frontend-inline-css");
              $(".page-content-section").append(contentPageCss);
              pageContentLoaded = true;
            });
          }
    
          if( typeof menu_embed_url !== 'undefined'  ) {
            pageContentLoaded = false;
            $(".page-menu-section").load(menu_embed_url+' '+menu_embed_element, function( response, status, xhr ) {
              var menuPageCss =  $( $.parseHTML(response) ).filter("#elementor-frontend-inline-css");
              $(".page-menu-section").append(menuPageCss);
              pageContentLoaded = true;
            });
          }

          if( typeof collection_menu_embed_url !== 'undefined'  ) {
            pageContentLoaded = false;
            $(".collection_menu_embed_url").load(collection_menu_embed_url+' '+collection_menu_embed_element, function( response, status, xhr ) {
              var menuPageCss =  $( $.parseHTML(response) ).filter("#elementor-frontend-inline-css");
              $(".collection_menu_embed_url").append(menuPageCss);
              pageContentLoaded = true;
            });
          }
          
        }
      }, 200);
      
      const checkIFPageElementsLoaded = setInterval(function(){
        if( pageContentLoaded ) {
          $.each( scriptsToLoad, function( key, value ) {
            $.getScript(value);
          });
          $('body').addClass('brand-page-loaded');
          clearInterval(checkIFPageElementsLoaded);
        }
      }, 200);

      /*

      collection_menu_embed_url = $('.collection_menu_embed_url').attr('data-embed-url');
      if( typeof collection_menu_embed_url !== 'undefined' ) {
      	$(".sf-custom-brand-menu").html(collection_menu_embed_url);
      }*/
      
      $('.page-load-content-section').each(function(){
        let pageContentLoadURL = $(this).attr('data-embed-url');
        let pageContentLoadElement = $(this).attr('data-embed-content');
        let contentPanel = $(this);
        $.get(pageContentLoadURL, function(response, status, xhr) {
			mainCustomCss = $( $.parseHTML(response) ).filter("#wp-custom-css");
            var mainCPageCss =  $( $.parseHTML(response) ).filter("#elementor-frontend-inline-css");
			$(contentPanel).append(mainCustomCss);
            $(contentPanel).append(mainCPageCss);
		})
        contentPanel.load(pageContentLoadURL+' '+pageContentLoadElement, function( response, status, xhr ) {
            var mainPageCss =  $( $.parseHTML(response) ).filter("#elementor-frontend-inline-css");
            $("#MainContent").append(mainPageCss);
        });
        /*$.get(pageContentLoadURL, function(response, status, xhr) {
            var bodyClasses =  $( $.parseHTML(response) ).filter("#bodyClasses");
            //alert(bodyClasses);
          $.each(bodyClasses, function(index, value) {
            const bodyClassars = value.classList.toString();
            //const bodyClass = bodyClassars.split(" ");
            
            //alert(bodyClassars);
            //console.log(value.classList);
           //$.each(bodyClass, function(classIndex, classValue) { 
              //console.log(index1 + ': ' + value1);
              contentPanel.addClass(bodyClassars);
            //});
          });
            //console.log(bodyClasses.classList);
            contentPanel.html(response); // Any <script> tags in the response string will execute
            
        });*/
      })

      const checkIFSliderElementsLoaded = setInterval(function(){
        if( $('.hajs-slick').length > 0 ) {
          console.log('exist');
          $('.hajs-slick').slick({
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  infinite: true,
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
          });
          clearInterval(checkIFSliderElementsLoaded);
        }
      }, 200);

          
    })
  })
}